import React from "react";
import "./styles.css";

export default function Header() {
  return <h5 className="header">What's the weather like in...</h5>;
}
